import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    frameId: String
  }

  connect() {
    this.cloneInserted = false
    this.handleFrameLoad = this.handleFrameLoad.bind(this)

    const insertionTarget = this.insertionTarget()
    if (!insertionTarget || this.hasExistingFrame()) return

    this.frame = document.createElement("turbo-frame")
    this.frame.id = this.frameIdValue
    this.frame.setAttribute("src", this.urlValue)
    this.frame.setAttribute("loading", "eager")
    this.frame.classList.add("sealed-products-frame", "article-sealed-products-top")
    this.frame.addEventListener("turbo:frame-load", this.handleFrameLoad)

    insertionTarget.insertAdjacentElement("afterend", this.frame)
    this.cloneLoadedWidget()
  }

  disconnect() {
    if (this.frame) {
      this.frame.removeEventListener("turbo:frame-load", this.handleFrameLoad)
    }
  }

  insertionTarget() {
    const firstContainer = this.element.querySelector(".spoiler-card-container, #spoiler-card-container")
    if (!firstContainer) return null

    const cards = firstContainer.querySelectorAll(".spoiler-card")
    if (cards.length === 0) return null

    return cards[Math.min(3, cards.length - 1)]
  }

  hasExistingFrame() {
    return Array.from(this.element.querySelectorAll("turbo-frame"))
      .some((frame) => frame.id === this.frameIdValue)
  }

  handleFrameLoad() {
    if (!this.frame.querySelector(".sealed-products-widget")) {
      this.frame.remove()
      this.frame = null
      return
    }

    this.cloneLoadedWidget()
  }

  cloneLoadedWidget() {
    if (this.cloneInserted || !this.frame) return

    const widget = this.frame.querySelector(".sealed-products-widget")
    if (!widget) return

    const wrapper = document.createElement("div")
    wrapper.classList.add("article-sealed-products-clone", "sealed-products-frame")

    const clone = widget.cloneNode(true)
    this.removeStaticIds(clone)
    wrapper.appendChild(clone)
    this.element.appendChild(wrapper)
    this.cloneInserted = true
  }

  removeStaticIds(element) {
    if (element.id) element.removeAttribute("id")
    element.querySelectorAll("[id]").forEach((node) => node.removeAttribute("id"))
  }
}
